<template>
  <div>
    <h2>Уведомление</h2>

    <br/>
    <br/>



    <el-table :data="items" style="width: 100%">
      <el-table-column
          type="index"
          label="#"
          width="50">
      </el-table-column>
      <el-table-column
          label="БИН">
        <template #default="scope">
          <a @click="openNotificationModal(scope.row)" href="#">
            {{ scope.row.bin }}
          </a>
        </template>
      </el-table-column>

      <el-table-column label="Название ДО">
        <template #default="scope">
          {{ scope.row.kindergartenName }}
        </template>
      </el-table-column>
      <el-table-column label="LMS ID">
        <template #default="scope">
          {{ scope.row.lmsId }}
        </template>
      </el-table-column>
      <el-table-column label="Населенный пункт">
        <template #default="scope">
          {{ getKatoNameRu(scope.row.katoCode) }}
        </template>
      </el-table-column>

      <el-table-column label="Адрес">
        <template #default="scope">
          {{ scope.row.address }}
        </template>
      </el-table-column>



      <el-table-column  label="Статус">
        <template #default="scope">
          {{ getLastMessageStatusText(scope.row.lastMessageStatus) }}
        </template>
      </el-table-column>


      <el-table-column label="Финансирование">
        <template #default="scope">
          {{ getFundingStatusText(scope.row.fundingStatus) }}
        </template>
      </el-table-column>

      <el-table-column label="Исполнитель">
        <template #default="scope">
          {{ scope.row.fundingStatusSuspendedByUser }}
        </template>
      </el-table-column>
    </el-table>
  </div>


  <!-- Modal component -->
  <b-modal v-model="showModal" :title="messageModalTitle" size="xl">
    <form class="mb-12">
      <section>
        <div class="container py-5.">
          <div style="width: 100%; padding-bottom: 5px">
            <div class="row">
              <div class="col-auto">
                <b class="padding-r-5px">Населенный пункт:</b>
                {{getKatoNameRu(lmsSystemNotificationDto?.katoCode)}}
              </div>


              <div class="col-auto" >
                <b class="padding-r-5px">Адрес:</b>
                {{lmsSystemNotificationDto?.address}}
              </div>

              <div class="col-auto">
                <b class="padding-r-5px">Финансирование:</b>
                {{ getFundingStatusText(lmsSystemNotificationDto?.fundingStatus) }}
              </div>

              <div class="col-auto">
                <b class="padding-r-5px">Контакты:</b>
                <input v-if="lmsSystemNotificationDto?.id"
                       v-model="lmsSystemNotificationDto.directorPhone"
                       placeholder="+7(777)777-7777"/>

                <a @click="updatePhone" class="btn btn-sm btn-success" style="margin-top: -5px;margin-left: 5px;">Сохранить</a>
              </div>

            </div>
          </div>

          <div class="messaging">
            <div class="inbox_msg">
              <div class="mesgs">
                <div class="msg_history">

                  <div v-if="messages.length && messages[0].totalRowCounts > messages.length"
                  style="text-align: center; padding-top: 10px; font-size: 14px; cursor: pointer; text-decoration: underline">
                    <a @click="loadOldMessages">&lt;&lt;Загрузить старые сообщение &gt;&gt;</a>
                  </div>

                  <!--                      -->
                  <div :class="item.sendByManager ? 'incoming_msg' : 'outgoing_msg'" v-for="item in messages">
                    <div class="incoming_msg_img" v-if="item.sendByManager">
                      <img src="https://ptetutorials.com/images/user-profile.png" alt="sunil">
                    </div>
                    <div :class="item.sendByManager ? 'received_msg' : 'sent_msg'">
                      <div :class="item.sendByManager ? 'received_withd_msg' : ''">
                        <p>
                          {{item.message}}
                        </p>
                        <div v-for="file in item.fileDtos">
                          <a href="javascript:void(0)" @click="downloadFile(file)" style="font-size: 10px">{{file.fileName}} ({{(file.size / 1024).toFixed(2)}}Kb)</a>
                        </div>
                        <span class="time_date">
                          {{ item.createdAt }} | {{item.createdByFullName}}  <span style="float: right; margin-right: 5px">{{getLastMessageStatusText(item.status)}}</span>
                        </span>
                      </div>
                    </div>
                  </div>


                </div>
                <div class="type_msg" v-if="lmsSystemNotificationDto?.notificationStatus == 'OPEN'">
                  <div class="input_msg_write">
                    <input type="text"
                           v-model="messageDto"
                           class="write_msg"
                           @keyup.enter="messageDto.trim() && sendMessage()"
                           @keypress.enter.prevent
                           placeholder="Введите текст сообщение" />
                    <button class="msg_send_btn" type="button"
                            @click="sendMessage()">
                      <font-awesome-icon :icon="['fas', 'fa-paper-plane']" />
                    </button>

                    <button class="upload_send_btn" type="button"
                            @click="triggerFileInput">
                      <font-awesome-icon :icon="['fas', 'fa-upload']" />
                    </button>

                    <input type="file" id="fileUpload"
                           ref="fileInput"
                           @change="handleFileUpload"
                           multiple
                           style="display: none"
                           accept=".pdf, .doc, .docx, .xls, .xlsx" class="form-control"/>
                  </div>
                  <div class="selected-file-item">
                    <span v-for="(file, index) in messageSelectedFiles" :key="index">
                     {{index + 1}}) {{file.name}}
                       <a @click="removeFile(index)">❌</a>
                    </span>
                  </div>
                </div>
              </div>
            </div>

          </div>

        </div>
      </section>
    </form>

    <!-- Кастомные кнопки в футере -->
    <template #footer>
      <b-button variant="secondary" @click="showModal = false">Закрыть</b-button>
<!--      <b-button variant="primary" @click="confirmAction">ОК</b-button>-->
    </template>
  </b-modal>

  <vue-loading :active.sync="isLoading" :is-full-page="true"></vue-loading>
</template>

<script lang="ts">
import {defineComponent, ref, onMounted, reactive, watch} from 'vue';
import {
  downloadReportFile
} from '@/services/reportService';
import {
  KdgNotificationSearchParam,
  KdgLmsSystemNotificationDto,
  KdgLmsSystemNotificationMessageDto,
  KdgLmsSystemNotificationMessageRequestDto
} from '@/types/report';
import {PageResponse} from "@/types/pageResponse";
import Multiselect from "vue-multiselect";
import {Kato} from "@/types/kindergarten";
import cacheService from "@/services/cacheService";
import authService from "@/services/authService";
import {
  findAllLmsSystemNotification,
  findByIdLmsSystemNotification,
  getLmsSystemNotificationMessages,
  sendLmsSystemNotificationMessage,
  sendLmsSystemNotificationMessageWithFiles,
} from "@/services/notificationService";
import {showErrorNotification} from "@/utils/notificationUtils";
import VueLoading from "vue-loading-overlay";
import 'vue-loading-overlay/dist/css/index.css';
import {updateUserPhone} from "@/services/userService";
import {downloadFileById} from "@/services/fileService";
import {saveAs} from "file-saver";
// import {TheMask} from "vue-the-mask";

export default defineComponent({
  name: 'KdgClientNotification',
  components: {Multiselect, VueLoading},
  setup() {
    const pageResponse = ref<PageResponse<KdgLmsSystemNotificationDto>>();
    const items = ref<KdgLmsSystemNotificationDto[]>([]);
    const currentPage = ref(1);
    const page = ref(1);
    const searchParams = reactive(new KdgNotificationSearchParam());
    const searchMessageParams = reactive(new KdgNotificationSearchParam());
    const kato = ref<Kato | null>(null);
    const katoList = ref<Kato[]>([]);
    const isLoading = ref(false);
    const isFormLoading = ref(false);
    const showModal = ref(false);
    const hasAccess = authService.hasAccess;
    const adminRoles: string[] = authService.getAdminRoles();
    let lmsSystemNotificationDto = ref<KdgLmsSystemNotificationDto | null>(null);
    let messages = ref<KdgLmsSystemNotificationMessageDto[]>([]);
    const messageDto = ref<string>('');
    const messageModalTitle = ref<string>('');
    const fileInput = ref<HTMLInputElement | null>(null);
    const messageSelectedFiles = ref<File[]>([]);
    searchMessageParams.pageSize = 10;
    const fetchCachedData = async () => {
      katoList.value = await cacheService.useKatoStore().fetchKato();
    };

    // const phone = ref("");
    // const { masked } = useMask(phone, { mask: "+# (###) ###-####" });

    const fetchReports = async (isPageDefault: boolean = false) => {
      try {
        if (isPageDefault) {
          searchParams.page = 0;
          currentPage.value = 1;
        }
        if (kato.value) {
          searchParams.katoCode = kato.value?.code;
        }
        pageResponse.value = await findAllLmsSystemNotification(searchParams);
        items.value = pageResponse.value.content;
      } catch (error) {
        console.error('Ошибка при получении отчетов:', error);
      }
    };

    const loadOldMessages = () => {
      searchMessageParams.page++;
      loadLmsSystemNotificationMessages(true);
    };


    const getLastMessageStatusText = (status: string) => {
      switch (status) {
        case 'DELIVERED':
          return 'Доставлено';
        case 'SENT':
          return 'Отправлено';
        default:
          return '';
      }
    };
    const getFundingStatusText = (status: string | undefined) => {
      switch (status) {
        case 'IN_PROGRESS':
          return 'Осуществляется';
        case 'SUSPENDED':
          return 'Приостановелено';
        default:
          return '';
      }
    };


    onMounted(() => {
      fetchReports();
      fetchCachedData();
    });

    const formattedKatoLabel = (item: any) => {
      return `${item.code} | ${item.nameRu}`;
    };

    const getKatoNameRu = (katoCode: number | undefined) => {
      const kato = katoList.value.find(kato => kato.code === katoCode);
      return kato ? kato.nameRu : "";
    }

    const openNotificationModal = (item: KdgLmsSystemNotificationDto) => {
      showModal.value = true;
      lmsSystemNotificationDto.value = item;
      messageDto.value = '';
      messageModalTitle.value = 'LMS ID: ' + item.lmsId + ', БИН: ' + item.bin + ", " + item.kindergartenName;
      searchMessageParams.page = 0;
      messageSelectedFiles.value = [];
      console.log('openNotificationModal', item);

      if (item.kdgNotificationId) {
        loadLmsSystemNotificationMessages();
      } else {
        messages.value = [];
      }
    }


    const sendMessage =  async () => {
      if (!messageDto.value.trim().length) {
        showErrorNotification('Сообщение пустое');
        return;
      }

      if (messageSelectedFiles.value.length) {
        sendMessageWithFiles();
        return;
      }
      if (lmsSystemNotificationDto) {
        const dto = ref<KdgLmsSystemNotificationMessageRequestDto>({
          message: messageDto.value,
          lmsSystemId: lmsSystemNotificationDto.value?.id,
          kdgNotificationId: lmsSystemNotificationDto.value?.kdgNotificationId
        });
        const result = await sendLmsSystemNotificationMessage(dto.value);
        if (result) {
          messageDto.value = '';
          loadLmsSystemNotificationMessages();
        }
      }
    }
    // Upload file using FormData
    const sendMessageWithFiles = async () => {
      // if (!messageSelectedFiles.value) {
      //   alert("Please select a file first!");
      //   return;
      // }

      const formData = new FormData();
      if (lmsSystemNotificationDto.value?.kdgNotificationId) {
        formData.append('kdgNotificationId', lmsSystemNotificationDto.value.kdgNotificationId);
      }
      if (lmsSystemNotificationDto.value?.id) {
        formData.append('lmsSystemId', lmsSystemNotificationDto.value.id + '');
      }
      formData.append('message', messageDto.value);

      for (let i = 0; i < messageSelectedFiles.value.length; i++) {
        formData.append("file[]", messageSelectedFiles.value[i], messageSelectedFiles.value[i].name); // Attach file to FormData
      }

      try {
        const result = await sendLmsSystemNotificationMessageWithFiles(formData);
        if (result) {
          messageDto.value = '';
          loadLmsSystemNotificationMessages();
        }
        // console.log("Upload success:", response.data);
        alert("File uploaded successfully!");
      } catch (error) {
        console.error("Upload error:", error);
        alert("File upload failed.");
      }
    }

    // Метод для триггера input
    const triggerFileInput = () => {
      if (fileInput.value) {
        fileInput.value.click(); // Use `.value` to access the DOM element
      }
      // const fileInput = ref<HTMLInputElement | null>(null);
      // if (fileInput.value) {
      //   fileInput.value.click();
      // }
    };
    const handleFileUpload = (event: any) => {
      console.log(event.target.files)
      const files = event.target.files;
      if (!files.length) {
        showErrorNotification("Выберите файл для загрузки");
        return;
      }

      // Вывод информации о файлах в консоль
      console.log("Выбранные файлы:", files);

      // Пример: валидация файла
      // const allowedTypes = ['application/pdf', 'application/msword',
      //   'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      //   'application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'];
      //
      // for (const file of files) {
      //   if (!allowedTypes.includes(file.type)) {
      //     showErrorNotification(`Файл "${file.name}" имеет неподдерживаемый формат!`);
      //     return;
      //   }
      // }

      // messageSelectedFiles.value = files;
      messageSelectedFiles.value = [...files];
    }
    const removeFile = (index: number) => {
      messageSelectedFiles.value.splice(index, 1);
    }


    const loadLmsSystemNotificationMessages = async (isAppendMessage: boolean = false) => {
      const item = await getLmsSystemNotificationMessages(lmsSystemNotificationDto.value?.kdgNotificationId, searchMessageParams, true);

      if (isAppendMessage) {
        messages.value.unshift(...item.content);
      } else {
        messages.value = item.content;
      }
    }


    const updatePhone =  async () => {
      if (!lmsSystemNotificationDto.value?.directorPhone) {
        showErrorNotification('Поля контакт пустое');
        return;
      }

      if (lmsSystemNotificationDto) {
        await updateUserPhone(lmsSystemNotificationDto.value.directorPhone);
      }
    }

    const downloadFile = async (file: any) => {
      isLoading.value = true;
      const response = await downloadFileById(file.id);
      const blob = new Blob([response.data], {type: file.contentType});
      saveAs(blob, file.fileName);
      isLoading.value = false;
    }

    return {
      items,
      pageResponse,
      page,
      currentPage,
      searchParams,
      isLoading,
      kato,
      katoList,
      isFormLoading,
      showModal,
      adminRoles,
      lmsSystemNotificationDto,
      messageDto,
      messages,
      messageModalTitle,
      fileInput,
      messageSelectedFiles,
      hasAccess,
      fetchReports,
      loadOldMessages,
      formattedKatoLabel,
      getKatoNameRu,
      getLastMessageStatusText,
      getFundingStatusText,
      openNotificationModal,
      sendMessage,
      handleFileUpload,
      triggerFileInput,
      removeFile,
      downloadFile,
      updatePhone
    };
  },


});
</script>

<style scoped>

.rejected-status {
  color: red;
}


.open-modal-btn {
  display: block;
  margin: 20px auto;
  padding: 10px 20px;
  background-color: #4caf50;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.open-modal-btn:hover {
  background-color: #45a049;
}

.modal {
  display: block;
  position: fixed;
  z-index: 2;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
}

.modal-content {
  background-color: #fefefe;
  margin: 15% auto;
  padding: 20px;
  border: 1px solid #888;
  width: 400px;
  border-radius: 10px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
}

h4 {
  text-align: center;
}

.form-group {
  margin-bottom: 15px;
}

.form-group label {
  display: block;
  margin-bottom: 5px;
}

.form-group input {
  width: 100%;
  padding: 8px;
  box-sizing: border-box;
  border: 1px solid #ccc;
  border-radius: 5px;
}

.submit-btn {
  width: 100%;
  padding: 10px;
  background-color: #4caf50;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.submit-btn:hover {
  background-color: #45a049;
}

.close-modal-btn {
  margin-top: 10px;
  width: 100%;
  padding: 10px;
  background-color: #f44336;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.close-modal-btn:hover {
  background-color: #e31b0c;
}


/*  chat */


.inbox_msg {
  border: 1px solid #c4c4c4;
  clear: both;
  overflow: hidden;
}
.top_spac{ margin: 20px 0 0;}

.incoming_msg_img {
  display: inline-block;
  width: 6%;
}
.incoming_msg_img img {
  height: 40px;
}
.received_msg {
  display: inline-block;
  padding: 0 0 0 10px;
  vertical-align: top;
  width: 92%;
}
.received_withd_msg p {
  background: #ebebeb none repeat scroll 0 0;
  border-radius: 3px;
  color: #646464;
  font-size: 14px;
  margin: 0;
  padding: 5px 10px 5px 12px;
  width: 100%;
}
.time_date {
  color: #747474;
  display: block;
  font-size: 12px;
  margin: 8px 0 0;
}
.received_withd_msg { width: 57%;}
.mesgs {
  float: left;
  padding: 0px 15px 0 25px;
  width: 100%;
}

.sent_msg p {
  background: #05728f none repeat scroll 0 0;
  border-radius: 3px;
  font-size: 14px;
  margin: 0; color:#fff;
  padding: 5px 10px 5px 12px;
  width:100%;
}
.outgoing_msg, .incoming_msg { overflow:hidden; margin:20px 0 20px;}
.sent_msg {
  float: right;
  width: 46%;
}
.input_msg_write input {
  background: rgba(0, 0, 0, 0) none repeat scroll 0 0;
  border: medium none;
  color: #4c4c4c;
  font-size: 15px;
  min-height: 48px;
  width: 100%;
}

.type_msg {border-top: 1px solid #c4c4c4;position: relative;}

.msg_send_btn {
  background: #05728f none repeat scroll 0 0;
  border: medium none;
  border-radius: 50%;
  color: #fff;
  cursor: pointer;
  font-size: 17px;
  height: 33px;
  position: absolute;
  right: 35px;
  top: 11px;
  width: 33px;
}
.upload_send_btn {
    background: #05728f none repeat scroll 0 0;
    border: medium none;
    border-radius: 50%;
    color: #fff;
    cursor: pointer;
    font-size: 17px;
    height: 33px;
    position: absolute;
    right: 0;
    top: 11px;
    width: 33px;
  }
.messaging { padding: 0 0 50px 0;}
.msg_history {
  height: 516px;
  overflow-y: auto;
}

.selected-file-item span {
  font-size: 10px;
  padding-right: 10px;
  a {
    text-decoration: none;
    cursor: pointer;
  }
}

.padding-r-5px {
  padding-right: 5px;
}

</style>
